import { useStepFeedbackAdmin } from "@/app/peopleQueries";
import { plural } from "@/lib/plural";

/** Счётчик отзывов студентов на шаг (SP5): «3 отзыва · ★ 4,3»; без отзывов — честно «отзывов пока нет». */
export function FeedbackBadge({ stepId }: { stepId: string }) {
  const q = useStepFeedbackAdmin(stepId);
  if (q.isError) return null;
  const n = q.data?.n ?? 0;
  const text = !q.data ? "отзывы…" : n === 0 ? "отзывов пока нет" : `${n} ${plural(n, "отзыв", "отзыва", "отзывов")} · ★ ${q.data.avg.toFixed(1).replace(".", ",")}`;
  return (
    <span className="font-mono text-[11px] text-ink2" data-testid="feedback-badge" title="отзывы студентов на шаг — подробно в аналитике">
      {text}
    </span>
  );
}
